import { TextInput } from '@pandiafi/design-system'
import { Field, FieldProps } from 'formik'
import { t } from 'i18next'
import React from 'react'

import FormFieldWrapper from 'components/FormField'

export const StreetAddressLine2Field: React.FC = () => {
  return (
    <Field name="newAddress.streetAddressLine2">
      {({ field, meta }: FieldProps) => (
        <FormFieldWrapper
          name={field.name}
          label={t('terminateContract:labels.streetAddressLine2')}
          className="min-tablet:flex-1"
          meta={meta}
          labelBold
        >
          <TextInput {...field} />
        </FormFieldWrapper>
      )}
    </Field>
  )
}
